import Vue from "vue";
import router, { dynamicRoutes } from "@/router";
import { MessageBox } from "element-ui";
import Cookies from "js-cookie";
import store from "@/store";

export const hasPermission = (roles, item) => {
  if (item.meta && item.meta.auth) {
    //includes返回布尔值
    return roles.includes(item.meta.auth);
  } else {
    return true;
  }
};

const permission = async () => {
  const result = await Vue.axios.post("GET_LOGIN_USER_INFO", true, {
    showLoading: false,
  });
  console.log("路由拦截调试", result);
  if (result.data.authIds === "") {
    MessageBox.confirm("您没有权限，请联系管理员", "提示", {
      confirmButtonText: "确定",
      type: "warning",
      showClose: false,
      showCancelButton: false,
      closeOnClickModal: false,
    }).then(() => {
      Vue.axios.get("NEW_LOGOUT", "").then((result) => {
        store.dispatch("user/logout");
        window.location.replace(result.data);
      });
    });
  }

  if (result.code == 2100) {
    process.env.NODE_ENV === "development"
      ? ""
      : window.location.replace(result.data);
  } else {
    if (result.data?.firstLogin) {
      MessageBox.confirm("您首次登录，还没有配置权限，请联系管理员", "提示", {
        confirmButtonText: "确定",
        type: "warning",
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
      }).then(() => {
        Vue.axios.get("NEW_LOGOUT", "").then((result) => {
          store.dispatch("user/logout");
          window.location.replace(result.data);
        });
      });
    } else {
      Cookies.set("jobNumber", result.data.jobNumber);
      //判断是否已经缓存过内容
      store.dispatch("user/setUserInfo", result.data);
      sessionStorage.setItem("userInfo", JSON.stringify(result.data));
      console.log("router", router);
      router.push({ path: "/home" });
    }
  }

  // 全局路由拦截
  router.beforeEach((to, from, next) => {
    store.dispatch("user/setApiCancel");
    if (sessionStorage.getItem("userInfo")) {
      let info = JSON.parse(sessionStorage.getItem("userInfo"));
      const authIds = info.authIds.split(",");
      if (to.path === "/") {
        if (authIds.includes("22")) {
          next({ name: "home" });
        } else if (authIds.includes("1")) {
          next({ name: "ohome" });
        } else {
          const firstRoute = dynamicRoutes.filter(
            (item) => item.meta.auth === authIds[0]
          );
          next({ name: firstRoute[0]["children"][0]["name"] });
        }
      }

      if (!from.name) {
        store.commit("user/SET_SIDEBAR_LIST", []);
        store.dispatch("user/setSidebarList", authIds);
      }
      next();
    }
  });
};

export default permission;

// // 全局路由拦截
// router.beforeEach((to, from, next) => {
//   // 判断是否登录，未登录就重定向到统一登录
//   Vue.axios
//     .post("GET_LOGIN_USER_INFO", true, { showLoading: false })
//     .then((result) => {
//       console.log("路由拦截调试", result);

//       if (result.code == 2100) {
//         process.env.NODE_ENV === "development"
//           ? ""
//           : window.location.replace(result.data);
//       } else {
//         if (result.data?.firstLogin) {
//           MessageBox.confirm(
//             "您首次登录，还没有配置权限，请联系管理员",
//             "提示",
//             {
//               confirmButtonText: "确定",
//               type: "warning",
//               showClose: false,
//               showCancelButton: false,
//               closeOnClickModal: false,
//             }
//           ).then(() => {
//             Vue.axios.get("NEW_LOGOUT", "").then((result) => {
//               store.dispatch("user/logout");
//               window.location.replace(result.data);
//             });
//           });
//         } else {
//           Cookies.set("jobNumber", result.data.jobNumber);
//           //判断是否已经缓存过内容
//           if (!sessionStorage.getItem("userInfo")) {
//             store.dispatch("user/setUserInfo", result.data);
//             // console.log(sessionStorage.getItem('menu'))
//             let a = JSON.parse(sessionStorage.getItem("menu"))[0];
//             next({ ...a, replace: true });
//           } else {
//             // let a = JSON.parse(sessionStorage.getItem('menu'))
//             let info = JSON.parse(sessionStorage.getItem("userInfo"));
//             info.authIds = result.data.authIds;
//             info.setTargetPermissions = result.data.setTargetPermissions;
//             info.marketDataScope = result.data.marketDataScope;
//             sessionStorage.setItem("userInfo", JSON.stringify(info));
//             const authIds = info.authIds.split(",");
//             if (to.path === "/") {
//               console.log("authIds", authIds);
//               if (authIds.includes("22")) {
//                 next({ name: "home" });
//               } else if (authIds.includes("1")) {
//                 next({ name: "ohome" });
//               } else {
//                 const firstRoute = dynamicRoutes.filter(
//                   (item) => item.meta.auth === authIds[0]
//                 );
//                 next({ name: firstRoute[0]["children"][0]["name"] });
//               }
//             }
//             if (!from.name) {
//               store.commit("user/SET_SIDEBAR_LIST", []);
//               // console.log(result.data.authIds?.split(','),'------------------------------')
//               store.dispatch(
//                 "user/setSidebarList",
//                 result.data.authIds?.split(",")
//               );
//             }
//             // console.log(123)
//             // store.dispatch('user/setSidebarList',result.data.authIds?.split(','))
//             // console
//             // if(b.length==0){
//             //   alert("无权限")
//             //   console.log("::::::::")
//             //   next({ ...a[0], replace: true })
//             // }
//           }
//         }
//         next();
//       }
//     })
//     .catch((error) => {
//       // 处理 getJSON 和 前一个回调函数运行时发生的错误
//       console.log("发生错误！", error);
//     });
// });
